import InputSectionGroup from './InputSectionGroup';

export default InputSectionGroup;
